import styled from 'styled-components'
import { resetButton } from 'styles/mixins'
import IconComponent from 'themes/IconComponent'

export const StyledAddressLabelButtonContainer = styled.button<{ selected?: boolean }>`
	${resetButton}
  width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 1rem;
	gap: 0.5rem;
	background-color: var(--bgLight);
	border-radius: var(--borderRadiusM);
	border: solid 1px;
	border-color: ${({ selected }) => (selected ? 'var(--primary)' : 'transparent')};
	box-shadow: var(--shadowSmall);

	transition: border-color 0.125s ease-in-out;
`

export const StyledAddressLabelIcon = styled(IconComponent)`
	width: 1.5rem;
	height: 1.5rem;
`
